export default __webpack_public_path__ + "static/media/gift.a4072240.png";